// extracted by mini-css-extract-plugin
module.exports = {"container":"CommunityManagementHeader_container__3xtCk","title":"CommunityManagementHeader_title__1tNFc","rightContainer":"CommunityManagementHeader_rightContainer__282vp"};